import axios from '../../axios/index';

export default {

    getClassifications () {
        return axios.get('/api/v1/shop-drawings/cross-checking/classifications');
    },
    getRequestTypes () {
        return axios.get('/api/v1/shop-drawings/cross-checking/items/request-types');
    },
    getClassification (id) {
        return axios.get('/api/v1/shop-drawings/cross-checking/classifications/' + id);
    },
    getItems () {
        return axios.get('/api/v1/shop-drawings/cross-checking/items');
    },
    getItem (id) {
        return axios.get('/api/v1/shop-drawings/cross-checking/items/' + id);
    },
    createClassification (data) {
        let formData = new FormData();
        formData.append('name', data['name']);
        if (data['priority']) {
            formData.append('priority', data['priority']);
        }
        return axios.post('/api/v1/shop-drawings/cross-checking/classifications', formData);
    },
    updateClassification (id, data) {
        let formData = new FormData();
        formData.append('name', data['name']);
        return axios.post('/api/v1/shop-drawings/cross-checking/classifications/' + id, formData);
    },
    createItem (data) {
        let formData = new FormData();
        formData.append('name', data['name']);
        if (data['classification']) {
            formData.append('classification_id', data['classification']['id']);
        }
        if (data['priority']) {
            formData.append('priority', data['priority']);
        }
        if (data['request_types']) {
            if (Array.isArray(data['request_types']) && data['request_types'].length) {
                Object.values(data['request_types']).forEach((type, index) => {
                    formData.append('request_types['+index+']', JSON.stringify({
                        id: type.id,
                        name: type.name,
                    }));
                })
            } else {
                formData.append('request_types[]', null);
            }
        }
        return axios.post('/api/v1/shop-drawings/cross-checking/items', formData);
    },
    updateItem (id, data) {
        let formData = new FormData();
        formData.append('name', data['name']);
        if (data['classification']) {
            formData.append('classification_id', data['classification']['id']);
        }
        if (data['request_types']) {
            if (Array.isArray(data['request_types']) && data['request_types'].length) {
                Object.values(data['request_types']).forEach((type, index) => {
                    formData.append('request_types['+index+']', JSON.stringify({
                        id: type.id,
                        name: type.name,
                    }));
                })
            } else {
                formData.append('request_types[]', null);
            }
        }
        return axios.post('/api/v1/shop-drawings/cross-checking/items/' + id, formData);
    },
    rearrangeItems (items) {
        let formData = new FormData();
        formData.append('items', JSON.stringify(items))
        return axios.post('/api/v1/shop-drawings/cross-checking/items/set-priority', formData);
    },
    rearrangeClassifications (items) {
        let formData = new FormData();
        formData.append('items', JSON.stringify(items))
        return axios.post('/api/v1/shop-drawings/cross-checking/classifications/set-priority', formData);
    },
    removeClassification (id) {
        return axios.delete('/api/v1/shop-drawings/cross-checking/classifications/' + id);
    },
    removeItem (id) {
        return axios.delete('/api/v1/shop-drawings/cross-checking/items/' + id);
    },
    getLogs (type) {
        return axios.get('/api/v1/shop-drawings/cross-checking/' + type + '/changelog');
    },
};
